import t_03_1477 from './KZ.T.03.1477.svg'

export default [
  t_03_1477,
]
